import { getMainIata } from "../../../shared/utils";

const mock = {
	destination: {
		name: "Guarulhos Intl",
		city: "Rio de Janeiro",
		iata: getMainIata("RIO"),
		country: "BR",
		fixed: true
	},
	tripType: "OW"
};

export const fixedCitiesMock = {
	priceCalendar: {
		origin: {
			city: "Belo Horizonte",
			iata: getMainIata("BHZ"),
			fixed: true
		},
		...mock
	}
};

export const tripTypeSwitchMock = {
	priceCalendar: {
		...mock,
		tripTypeSwitch: true
	}
};

export default { priceCalendar: mock };
